export default __webpack_public_path__ + "static/media/user.e4297f64.svg";